module.exports = __webpack_public_path__ + "img/third.dc9d7e59.jpg";